class FAQManager {
  /**
   * Get current FAQ items from DOM
   */
  private getItems(): NodeListOf<HTMLElement> {
    return document.querySelectorAll('.faq-item');
  }

  /**
   * Initialize FAQ accordion functionality
   */
  init(): void {
    const items = this.getItems();
    if (items.length === 0) {
      return;
    }

    this.bindEvents();
    console.log(`FAQ initialized with ${items.length} items`);
  }

  /**
   * Bind click events to FAQ questions
   */
  private bindEvents(): void {
    const items = this.getItems();
    items.forEach((item) => {
      const question = item.querySelector('.faq-question');
      if (question) {
        // Remove old listeners by cloning
        const newQuestion = question.cloneNode(true) as HTMLElement;
        question.parentNode?.replaceChild(newQuestion, question);

        // Add new listener
        newQuestion.addEventListener('click', () => this.toggleItem(item));
        newQuestion.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleItem(item);
          }
        });

        // Set ARIA attributes
        newQuestion.setAttribute('role', 'button');
        newQuestion.setAttribute('tabindex', '0');
        newQuestion.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /**
   * Toggle FAQ item open/closed
   */
  private toggleItem(clickedItem: HTMLElement): void {
    const items = this.getItems();
    const question = clickedItem.querySelector('.faq-question');
    const isActive = clickedItem.classList.contains('active');

    // Close all other items
    items.forEach((item) => {
      const q = item.querySelector('.faq-question');
      item.classList.remove('active');
      if (q) {
        q.setAttribute('aria-expanded', 'false');
      }
    });

    // Toggle clicked item
    if (!isActive) {
      clickedItem.classList.add('active');
      if (question) {
        question.setAttribute('aria-expanded', 'true');
      }
    }
  }

  /**
   * Close all FAQ items
   */
  closeAll(): void {
    const items = this.getItems();
    items.forEach((item) => {
      item.classList.remove('active');
      const question = item.querySelector('.faq-question');
      if (question) {
        question.setAttribute('aria-expanded', 'false');
      }
    });
  }
}

// Export singleton
export const faqManager = new FAQManager();

// Auto-initialize
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    faqManager.init();
  });
}
